/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import uniqid from 'uniqid';

import { useConsent } from 'polaris-coreweb/exports';
import { ViewportChecker } from 'Components/protons/ViewportChecker';

import { Digiteka as SimpleDigiteka } from 'Components/molecules/Digiteka';

const Digiteka = ({
  viewport,
  monetising,
  breakpoints: {
    desktop: desktopBreakpoint,
    mobile: mobileBreakpoint,
  },
}) => {
  const consent = useConsent();

  if (
    (!Array.isArray(monetising) || monetising.length === 0)
    || (!consent)
  ) return false;

  const digitekaEl = monetising.find(item => item.service && item.service.toLowerCase() === 'digiteka');

  if (!digitekaEl) return false;

  const digitekaConfig = digitekaEl.config
  && Array.isArray(digitekaEl.config)
  && digitekaEl.config.reduce(
    (acc, curr) => ({ ...acc, [curr.key]: curr.value }),
    {},
  );

  const { id } = digitekaConfig;

  if (!id) return false;

  const DigitekaComponent = (
    <SimpleDigiteka
      id={id}
    />
  );

  return (
    <ViewportChecker
      range={viewport === 'desktop' ? desktopBreakpoint : mobileBreakpoint}
      key={uniqid('digiteka-')}
    >
      { DigitekaComponent }
    </ViewportChecker>
  );
};

Digiteka.protoTypes = {
  viewport: PropTypes.string,
  monetising: PropTypes.arrayOf(PropTypes.shape({
    service: PropTypes.string,
    enabled: PropTypes.bool,
    config: PropTypes.array,
  })).isRequired,
  breakpoints: PropTypes.shape({
    desktop: PropTypes.arrayOf(
      PropTypes.shape({
        desktop: PropTypes.shape({
          max: PropTypes.number,
          min: PropTypes.number,
        }),
        mobile: PropTypes.shape({
          max: PropTypes.number,
          min: PropTypes.number,
        }),
      }),
    ),
  }),
};

Digiteka.defaultProps = {
  viewport: 'desktop',
  breakpoints: [
    {
      desktop: {
        min: 1024,
        max: 9999,
      },
    },
    {
      mobile: {
        min: 0,
        max: 1023,
      },
    },
  ],
};

export const getDigiteka = (props = {}) => (
  <Digiteka
    {...props}
  />
);
